export function useSlug() {
  const route = useRoute();

  return computed(() =>
    ensureArray(route.params.slug).filter(Boolean).join('/')
  );
}
